// removed by extract-text-webpack-plugin
module.exports = {"form-validation-message-wrapper":"form-validation-message-wrapper","formValidationMessageWrapper":"form-validation-message-wrapper","show":"show","error-message":"error-message","errorMessage":"error-message"};


//////////////////
// WEBPACK FOOTER
// ./src/components/portal/controls/validationTopErrorMessage/style.scss
// module id = 960
// module chunks = 0